import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mdp-ExternalLink link-icon"
}
const _hoisted_2 = { class: "node-title" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "node-body" }

import { NodeStatus } from "@medapro-types/services/healthChecks";
import { computed } from "vue";
import Spinner from "@common/components/Spinner.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'StatusNode',
  props: {
    title: {},
    description: {},
    status: {},
    link: {},
    isLinkInteractive: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;



function openLink() {
  if (props.link) {
    window.open(props.link);
  }
}

const indicators = computed(() => {
  switch (props.status) {
    case NodeStatus.Running:
      return {
        icon: "",
        bg: "bg-status-info"
      };
    case NodeStatus.Error:
      return {
        icon: "mdp-Error",
        bg: "bg-status-error"
      };
    case NodeStatus.Warning:
      return {
        icon: "mdp-Warning1",
        bg: "bg-status-warning"
      };
    case NodeStatus.Success:
      return {
        icon: "mdp-CheckCircle1",
        bg: "bg-status-success"
      };
  }

  return {
    icon: "",
    bg: "bg-status-info"
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["d-flex flex-column status-node", [indicators.value.bg, props.link && props.isLinkInteractive && 'link']]),
    onClick: openLink
  }, [
    (props.link && props.isLinkInteractive)
      ? (_openBlock(), _createElementBlock("i", _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (props.status === _unref(NodeStatus).Running)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
            _createVNode(Spinner)
          ]))
        : (_openBlock(), _createElementBlock("i", {
            key: 1,
            class: _normalizeClass(["node-icon", [indicators.value.icon]])
          }, null, 2)),
      _createElementVNode("span", null, _toDisplayString(props.title), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createTextVNode(_toDisplayString(props.description) + " ", 1),
      _createElementVNode("div", null, _toDisplayString(props.link), 1)
    ])
  ], 2))
}
}

})